import { render, staticRenderFns } from "./WeeklyScheduleSlot.vue?vue&type=template&id=2b511af6&"
import script from "./WeeklyScheduleSlot.vue?vue&type=script&lang=js&"
export * from "./WeeklyScheduleSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports